export const RECIPE_PAGE_NAME_MAPPINGS = {
  is_breakfast: 'breakfast',
  is_lunch: 'lunch',
  is_kids_meals: 'kids_meals',
  is_family_meals: 'family_meals',
  is_tacos: 'tacos',
  is_stir_fries: 'stir_fries',
  is_bakes: 'bakes',
  is_pastas: 'pastas',
  is_pizza: 'pizza',
  is_main_sides: 'main_sides',
  is_burgers: 'burgers',
  is_bowls: 'bowls',
  is_salads: 'salads',
  is_sandwiches: 'sandwiches',
  is_soups_stews: 'soups_stews',
  is_wraps: 'wraps',
  is_starters_and_sides: 'starters_sides',
};

export const GROCERIES_PAGE_NAME_MAPPINGS = {
  is_supplements: 'supplements',
  is_ready_to_eat: 'meals',
  is_kids: 'kids',
  is_produce: 'produce',
  is_sauces_condiments: 'sauces_condiments',
  is_meat_seafood: 'meat_seafood',
  is_plant_proteins: 'plant_based_proteins',
  is_grains_pastas: 'grains_pastas',
  is_bread_bakery: 'bread_bakery',
  is_cereal_oats: 'cereal_oats',
  is_snacks: 'snacks',
  is_sweets: 'sweets',
  is_dairy_eggs: 'dairy_eggs',
  is_pantry: 'pantry',
  is_beverages: 'drinks',
  is_sides: 'sides',
};
